import React from 'react'
import Header from '../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../component/custom-hooks/get-nav';

const MySpaceLayout = () => {
  const navList = useNav();
  let { mySpaceBottomNav, topHeaderNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={mySpaceBottomNav} topTabs={topHeaderNav} />
      <Outlet />
    </div>
  )
}

export default MySpaceLayout
